import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toggleLinksSidebar } from "../../store/actions";
import BurgerIcon from "../common/BurgerIcon";
import ModulesSidebar from "../layout/ModulesSidebar";
import { AnimatePresence, motion } from "framer-motion";
import { userSetsSectionThunk } from "../../store/thunks";
import { useHistory } from "react-router";
import { useTranslation } from "react-i18next";

const ModuleHeader = ({ title, bgColor, number }) => {
  const dispatch = useDispatch();
  const [showMenu, setShowMenu] = useState(false);
  const [showSwitcher, setShowSwitcher] = useState(false);
  const history = useHistory();
  const currentSection = useSelector((state) => state.progress.section);
  const progress = useSelector((state) => state.progress);
  const lang = useSelector((state) => state.ui.lang);
  const { t } = useTranslation();

  const hasNumber = () => !!(number && number > 0);

  const currentSectionLabel =
    currentSection === "PMAgile" ? t("agileCourse") : t("waterfallCourse");
  const nextSectionLabel =
    currentSection === "PMAgile" ? t("waterfallCourse") : t("agileCourse");
  const switchSectionLabel =
    currentSection === "PMAgile"
      ? t("switchToWaterfallHeader")
      : t("switchToAgileHeader");

  const toggleSection = async () => {
    const nextSection =
      currentSection === "PMAgile" ? "PMWaterfall" : "PMAgile";
    await dispatch(userSetsSectionThunk(nextSection));
    const sectionName = nextSection === "PMAgile" ? "agile" : "waterfall";
    return history.push(progress.currentPosition[lang][sectionName + "Path"]);
  };

  return (
    <>
      <header>
        <div className="w-full flex justify-between items-center px-3 lg:hidden">
          <BurgerIcon />
          <div className="w-1/3">
            <img src="images/kickoff.png" alt="kickoff-beta" />
          </div>
        </div>

        {/* desktop section*/}
        <div className="hidden text-xl lg:flex w-full justify-between items-center">
          <div className={"flex space-x-5 items-baseline"}>
            <span className={"text-black font-bold uppercase"}>
              {currentSectionLabel}
            </span>
            <span>|</span>
            <span
              className="cursor-pointer text-indigo-800 text-sm"
              onClick={toggleSection}
            >
              {switchSectionLabel}
            </span>
          </div>

          <div
            onClick={() => dispatch(toggleLinksSidebar())}
            className="text-black cursor-pointer"
          >
            <i className="fas fa-bars" />
          </div>
        </div>

        {/* desktop header */}
        <div className={"hidden lg:block mt-5"}>
          <div className="font-bold py-2">
            {hasNumber() && (
              <span
                className={`bg-${bgColor} text-white px-2 py-1 mr-3 rounded rounded-tr-xlg`}
              >
                {number}.{" "}
              </span>
            )}
            <span className="text-black uppercase">{title}</span>
          </div>
        </div>

        {/* mobile section */}
        <div
          onClick={() => setShowSwitcher((old) => !old)}
          className={"flex justify-between items-center lg:hidden mt-5"}
        >
          <div className="font-bold py-2 text-xl">
            <span className="text-black uppercase">{currentSectionLabel}</span>
          </div>
          <div className="text-black cursor-pointer px-5">
            {showSwitcher ? (
              <i className="fas fa-chevron-down" />
            ) : (
              <i className="fas fa-chevron-right" />
            )}
          </div>
        </div>

        <AnimatePresence>
          {showSwitcher ? (
            <motion.div
              initial={{ height: 0 }}
              animate={{ height: "auto" }}
              exit={{ height: 0 }}
              transition={{ damping: 200 }}
            >
              <div>
                <span
                  className="cursor-pointer text-black uppercase"
                  onClick={toggleSection}
                >
                  {nextSectionLabel}
                </span>
              </div>
            </motion.div>
          ) : null}
        </AnimatePresence>

        {/* mobile header*/}
        <div
          onClick={() => setShowMenu((old) => !old)}
          className={"flex justify-between items-center lg:hidden mt-5"}
        >
          <div className="font-bold py-2 text-xl">
            <span className="text-black uppercase">{title}</span>
          </div>
          <div className="text-black cursor-pointer px-5">
            {showMenu ? (
              <i className="fas fa-chevron-down" />
            ) : (
              <i className="fas fa-chevron-right" />
            )}
          </div>
        </div>
      </header>

      <AnimatePresence>
        {showMenu ? (
          <motion.div
            initial={{ height: 0 }}
            animate={{ height: "auto" }}
            exit={{ height: 0 }}
            transition={{ damping: 200 }}
          >
            <ModulesSidebar />
          </motion.div>
        ) : null}
      </AnimatePresence>
    </>
  );
};

export default ModuleHeader;
